import { publicAssetsURL } from '#internal/nuxt/paths';export default publicAssetsURL("/content/assets/menu/mobile-menu__seg-trail.svg")